export default {
  // Header
  "title": "रैंडम पोकेमॉन जनरेटर",
  "subtitle": "अपनी पसंद के अनुसार रैंडम पोकेमॉन कैरेक्टर्स जनरेट करें",
  "home": "होम",
  "whichPokemonAmI": "मैं कौन सा पोकेमॉन हूँ?",
  "aboutUs": "हमारे बारे में",
  "contactUs": "संपर्क करें",
  "privacyPolicy": "गोपनीयता नीति",
  
  // Filters
  "filterTitle": "फ़िल्टर विकल्प",
  "generateButton": "रैंडम पोकेमॉन जनरेट करें",
  "generating": "जनरेट हो रहा है...",
  "numberOfPokemon": "पोकेमॉन की संख्या",
  "type": "प्रकार",
  "generation": "पीढ़ी",
  "minimumRarity": "न्यूनतम दुर्लभता (1-10)",
  "anyType": "कोई भी प्रकार",
  "anyGeneration": "कोई भी पीढ़ी",
  "anyRarity": "कोई भी दुर्लभता",
  "countingPokemon": "मिलान करने वाले पोकेमॉन की गिनती",
  "matchingPokemonCount": "फ़िल्टर से मिलान करने वाले {{count}} पोकेमॉन",
  
  // Pokemon Types
  "normal": "सामान्य",
  "fire": "आग",
  "water": "पानी",
  "electric": "बिजली",
  "grass": "घास",
  "ice": "बर्फ",
  "fighting": "लड़ाकू",
  "poison": "जहरीला",
  "ground": "धरती",
  "flying": "उड़ने वाला",
  "psychic": "मनोवैज्ञानिक",
  "bug": "कीड़ा",
  "rock": "पत्थर",
  "ghost": "भूत",
  "dragon": "ड्रैगन",
  "dark": "अंधेरा",
  "steel": "स्टील",
  "fairy": "परी",
  
  // Generations
  "Generation I": "पहली पीढ़ी",
  "Generation II": "दूसरी पीढ़ी",
  "Generation III": "तीसरी पीढ़ी",
  "Generation IV": "चौथी पीढ़ी",
  "Generation V": "पांचवीं पीढ़ी",
  "Generation VI": "छठी पीढ़ी",
  "Generation VII": "सातवीं पीढ़ी",
  "Generation VIII": "आठवीं पीढ़ी",
  "Generation IX": "नौवीं पीढ़ी",
  
  // Evolution Stage
  "evolutionStage": "विकास चरण",
  "evolutionStageAll": "सभी चरण",
  "evolutionStageFullyEvolved": "पूर्ण विकसित",
  "evolutionStageNotFullyEvolved": "पूरी तरह से विकसित नहीं",
  
  // About Section
  "aboutTitle": "रैंडम पोकेमॉन जनरेटर के बारे में",
  
  // Section titles
  "introTitle": "रैंडम पोकेमॉन जनरेटर में आपका स्वागत है",
  "howToUseTitle": "रैंडम पोकेमॉन जनरेटर का उपयोग कैसे करें",
  "benefitsTitle": "रैंडम पोकेमॉन जनरेटर के उपयोग के लाभ",
  "historyTitle": "पोकेमॉन का इतिहास",
  "popularPokemonTitle": "लोकप्रिय पोकेमॉन कैरेक्टर्स",
  "popularGamesTitle": "लोकप्रिय पोकेमॉन गेम्स",
  "tradingContestsTitle": "पोकेमॉन ट्रेडिंग और प्रतियोगिताएँ",
  "faqTitle": "अक्सर पूछे जाने वाले प्रश्न",
  "conclusionTitle": "आज ही पोकेमॉन के साथ अपनी रैंडम यात्रा शुरू करें!",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "पोकेमॉन और पोकेमॉन कैरेक्टर के नाम Nintendo के ट्रेडमार्क हैं।",
  "linksTitle": "उपयोगी लिंक्स",
  
  // About Us Page
  "aboutUsTitle": "हमारे बारे में",
  "aboutUsWhoWeAre": "हम कौन हैं",
  "aboutUsWhoWeAreContent1": "रैंडम पोकेमॉन जनरेटर में आपका स्वागत है, जो पोकेमॉन के उत्साही लोगों द्वारा बनाया गया एक फैन-मेड टूल है। हमारी यात्रा 2023 में शुरू हुई, जब कोडिंग और पोकेमॉन दोनों से प्यार करने वाले डेवलपर्स के एक समूह ने समुदाय के लिए एक उपयोगी टूल बनाने का फैसला किया।",
  "aboutUsWhoWeAreContent2": "हमारी टीम में डेवलपर्स, डिजाइनर्स और कंटेंट क्रिएटर्स शामिल हैं जो दुनिया भर के पोकेमॉन फैंस को सबसे अच्छा अनुभव प्रदान करने के लिए मिलकर काम करते हैं।",
  "aboutUsOurMission": "हमारा मिशन",
  "aboutUsOurMissionContent1": "हमारा उद्देश्य पोकेमॉन की दुनिया को हर किसी के लिए अधिक सुलभ और मज़ेदार बनाना है। हमारे टूल्स ट्रेनर्स को नए पोकेमॉन की खोज करने, संतुलित टीमें बनाने और सही पोकेमॉन को खोजने में मदद करने के लिए डिज़ाइन किए गए हैं।",
  "aboutUsOurMissionContent2": "हम पोकेमॉन फ्रैंचाइजी का सम्मान करते हुए समुदाय को मूल्य जोड़ने वाला एक आसान, सटीक और मनोरंजक अनुभव प्रदान करने के लिए प्रतिबद्ध हैं।",
  "aboutUsOurTeam": "हमारी टीम",
  "aboutUsOurTeamContent1": "हमारी विविध टीम वेब डेवलपमेंट, पोकेमॉन ज्ञान, यूजर एक्सपीरियंस डिज़ाइन, और कम्युनिटी मैनेजमेंट में विशेषज्ञता को एक साथ लाती है। हम पोकेमॉन के प्रति प्यार और उच्च गुणवत्ता वाले टूल्स बनाने की प्रतिबद्धता के साथ एकजुट हैं।",
  "aboutUsOurTeamContent2": "टीम का हर सदस्य रैंडम पोकेमॉन जनरेटर को बेहतर बनाने के लिए अपने अनूठे कौशल और दृष्टिकोण का योगदान देता है।",
  "aboutUsJoinUs": "हमसे जुड़ें",
  "aboutUsJoinUsContent": "हम हमेशा अपने समुदाय में शामिल होने के लिए उत्साही लोगों की तलाश में रहते हैं। चाहे आप एक डेवलपर, डिजाइनर, पोकेमॉन विशेषज्ञ या उत्साही उपयोगकर्ता हों, आपकी प्रतिक्रिया और योगदान का स्वागत है।",
  
  // Contact Us Page
  "contactUsTitle": "संपर्क करें",
  "contactUsGetInTouch": "संपर्क में रहें",
  "contactUsGetInTouchContent": "क्या आपके पास रैंडम पोकेमॉन जनरेटर के बारे में प्रश्न, सुझाव या प्रतिक्रिया है? हम आपसे सुनना चाहते हैं! नीचे हमारी टीम से संपर्क करने के तरीके दिए गए हैं।",
  "contactUsEmail": "ईमेल",
  "contactUsPhone": "फोन",
  "contactUsAddress": "पता",
  "contactUsHelpSupport": "सहायता और समर्थन",
  "contactUsHelpSupportContent": "क्या आपको हमारे टूल्स का उपयोग करने में मदद की आवश्यकता है या आप किसी समस्या का सामना कर रहे हैं? हमारी सपोर्ट टीम मदद के लिए यहाँ है।",
  "contactUsFAQ": "अक्सर पूछे जाने वाले प्रश्न",
  "contactUsFAQContent": "हमसे संपर्क करने से पहले, कृपया हमारे FAQ अनुभाग की जांच करें, जो कई सामान्य प्रश्नों और मुद्दों को कवर करता है।",
  "contactUsBugReport": "बग रिपोर्ट",
  "contactUsBugReportContent": "यदि आपको कोई बग या तकनीकी समस्या मिली है, तो कृपया 'बग रिपोर्ट' विषय लाइन के साथ हमें ईमेल भेजकर हमें बताएं।",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "गोपनीयता नीति",
  "privacyPolicyIntro": "परिचय",
  "privacyPolicyIntroContent": "रैंडम पोकेमॉन जनरेटर में, हम आपकी गोपनीयता का सम्मान करते हैं और आपके व्यक्तिगत डेटा की सुरक्षा के लिए प्रतिबद्ध हैं। यह गोपनीयता नीति बताती है कि जब आप हमारी वेबसाइट का उपयोग करते हैं, तो आपकी जानकारी कैसे एकत्र की जाती है, उपयोग की जाती है और सुरक्षित की जाती है।",
  "privacyPolicyInformation": "हम जो जानकारी एकत्र करते हैं",
  "privacyPolicyInformationContent": "हम अपनी सेवाओं को प्रदान करने और सुधारने के लिए न्यूनतम जानकारी एकत्र करते हैं। इसमें शामिल हो सकते हैं:",
  "privacyPolicyInformationItem1": "उपयोग डेटा (जैसे कि देखे गए पेज, साइट पर बिताया गया समय, उपयोग की गई सुविधाएँ)",
  "privacyPolicyInformationItem2": "डिवाइस जानकारी (ब्राउज़र प्रकार, ऑपरेटिंग सिस्टम, स्क्रीन रेज़ोल्यूशन)",
  "privacyPolicyInformationItem3": "आईपी पता और अनुमानित स्थान (केवल देश स्तर पर)",
  "privacyPolicyCookies": "कुकीज़ और समान तकनीकें",
  "privacyPolicyCookiesContent": "हम हमारी वेबसाइट पर आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। ये छोटी टेक्स्ट फाइलें हमें आपकी प्राथमिकताओं को याद रखने और हमारी साइट के उपयोग का विश्लेषण करने की अनुमति देती हैं। आप अपने ब्राउज़र सेटिंग्स के माध्यम से कुकीज़ को नियंत्रित कर सकते हैं।",
  "privacyPolicyThirdParty": "तृतीय-पक्ष सेवाएँ",
  "privacyPolicyThirdPartyContent": "हमारी वेबसाइट एनालिटिक्स प्रदाताओं और कंटेंट डिलीवरी नेटवर्क जैसी तृतीय-पक्ष सेवाओं का उपयोग कर सकती है। ये सेवाएँ हमारी वेबसाइट के आपके उपयोग के बारे में जानकारी एकत्र कर सकती हैं। हम यह सुनिश्चित करते हैं कि सभी तृतीय पक्ष आपकी गोपनीयता का सम्मान करते हैं और डेटा को उचित रूप से संसाधित करते हैं।",
  "privacyPolicySecurity": "डेटा सुरक्षा",
  "privacyPolicySecurityContent": "हम आपकी जानकारी को अनधिकृत पहुंच, परिवर्तन, प्रकटीकरण या विनाश से बचाने के लिए उचित सुरक्षा उपायों को लागू करते हैं। हालांकि, इंटरनेट पर कोई भी प्रसारण 100% सुरक्षित नहीं है, इसलिए हम पूर्ण सुरक्षा की गारंटी नहीं दे सकते।",
  "privacyPolicyChanges": "इस नीति में परिवर्तन",
  "privacyPolicyChangesContent": "हम समय-समय पर अपनी गोपनीयता नीति को अपडेट कर सकते हैं। हम इस पेज पर नई गोपनीयता नीति पोस्ट करके और 'अंतिम अपडेट' की तारीख को अपडेट करके आपको किसी भी परिवर्तन के बारे में सूचित करेंगे।",
  "privacyPolicyContact": "संपर्क करें",
  "privacyPolicyContactContent": "यदि आपके पास इस गोपनीयता नीति के बारे में कोई प्रश्न हैं, तो कृपया संपर्क पेज पर दी गई जानकारी के माध्यम से हमसे संपर्क करें।",
  "privacyPolicyLastUpdated": "अंतिम अपडेट",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "मैं कौन सा पोकेमॉन हूँ?",
  "whichPokemonAmISubtitle": "खोजें कि आपके लिए कौन सा पोकेमॉन सबसे उपयुक्त है",
  "enterYourName": "अपना नाम दर्ज करें",
  "namePlaceholder": "आपका नाम",
  "enterFavoriteColor": "अपना पसंदीदा रंग चुनें",
  "enterBirthMonth": "अपना जन्म महीना चुनें",
  "selectBirthMonth": "महीना चुनें",
  "enterPersonalityTrait": "अपना व्यक्तित्व लक्षण चुनें",
  "selectPersonalityTrait": "लक्षण चुनें",
  "findMyPokemon": "मेरा पोकेमॉन खोजें",
  "calculating": "गणना हो रही है...",
  "yourPokemonIs": "आपका पोकेमॉन है",
  "pokemonDescription": "विवरण",
  "personalityMatch": "व्यक्तित्व मेल",
  "yourCompatibility": "आपकी संगतता",
  "downloadImage": "इमेज डाउनलोड करें",
  "shareResult": "परिणाम साझा करें",
  "tryAgain": "पुनः प्रयास करें",
  "results": "परिणाम",
  "aboutTool": "इस टूल के बारे में",
  "howToUse": "उपयोग कैसे करें",
  "benefits": "लाभ",
  "faq": "अक्सर पूछे जाने वाले प्रश्न",
  "conclusion": "निष्कर्ष",
  
  // Error messages
  "nameRequired": "नाम आवश्यक है",
  "colorRequired": "कृपया एक रंग चुनें",
  "monthRequired": "कृपया एक महीना चुनें",
  "traitRequired": "कृपया एक व्यक्तित्व लक्षण चुनें",
  
  // Months
  "january": "जनवरी",
  "february": "फरवरी",
  "march": "मार्च",
  "april": "अप्रैल",
  "may": "मई",
  "june": "जून",
  "july": "जुलाई",
  "august": "अगस्त",
  "september": "सितंबर",
  "october": "अक्टूबर",
  "november": "नवंबर",
  "december": "दिसंबर",
  
  // Personality Traits
  "brave": "बहादुर",
  "calm": "शांत",
  "timid": "शर्मीला",
  "jolly": "खुश",
  "quiet": "शांत",
  "hasty": "जल्दबाज",
  "careful": "सावधान",
  "lonely": "अकेला",
  "bold": "साहसी",
  "relaxed": "आराम से",
  "impish": "शरारती",
  "modest": "विनम्र",
  
  // Additional translations for size matching feature
  "heightValid": "कृपया एक वैध ऊंचाई दर्ज करें (1-300 सेमी)",
  "weightValid": "कृपया एक वैध वजन दर्ज करें (1-500 किग्रा)",
  "enterDetails": "अपना विवरण दर्ज करें",
  "nameLabel": "नाम",
  "heightLabel": "ऊंचाई",
  "weightLabel": "वजन",
  "finding": "खोज रहा है...",
  "errorFinding": "आपका पोकेमॉन खोजने में त्रुटि",
  "matchResult": "{{name}} पोकेमॉन है...",
  "similarityScore": "समानता स्कोर",
  "downloadStarted": "इमेज तैयार हो रही है...",
  "downloadComplete": "इमेज सफलतापूर्वक डाउनलोड की गई!",
  "shareText": "मैंने खोजा कि मैं {{pokemon}} हूँ! आप कौन से पोकेमॉन हैं, इसे खोजें!",
  
  // Size matching feature
  "enterHeightWeight": "अपनी ऊंचाई और वजन दर्ज करें — देखें कौन सा पोकेमॉन आपसे मेल खाता है!",
  "whichPokemonMatchesSize": "कौन सा पोकेमॉन आपके आकार से मेल खाता है?",
  "youAreMostLike": "आप सबसे अधिक इसके समान हैं",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Hindi)
  "pokemonRandomizerPageAboutTitle": "परम पोकेमॉन रैंडमाइज़र अनुभव का अन्वेषण करें",
  "pokemonRandomizer_whatIsItTitle": "एक पोकेमॉन रैंडमाइज़र वास्तव में क्या है?",
  "pokemonRandomizer_featuresTitle": "हमारे पोकेमॉन रैंडमाइज़र टूल की मुख्य विशेषताएं",
  "pokemonRandomizer_whyUseTitle": "पोकेमॉन रैंडमाइज़र के साथ एक साहसिक कार्य क्यों शुरू करें?",
  "pokemonRandomizer_gettingStartedTitle": "शुरुआत करना: आपका पहला पोकेमॉन रैंडमाइज़र रन",
  "pokemonRandomizer_faqTitle": "पोकेमॉन रैंडमाइज़र: अक्सर पूछे जाने वाले प्रश्न",
  "pokemonRandomizerPageH1": "पोकेमॉन रैंडमाइज़र",
  "pokemonRandomizerPageSubtitle": "हमारे उन्नत रैंडमाइज़र उपकरण के साथ अद्वितीय पोकेमॉन अनुभव बनाएं।",

  // Sub-Footer
  subFooterToolsTitle: "उपकरण",
  subFooterRandomPokemonGeneratorLink: "रैंडम पोकेमॉन जेनरेटर",
  subFooterPokemonRandomizerLink: "पोकेमॉन रैंडमाइज़र",
  subFooterWhichPokemonAmILink: "मैं कौन सा पोकेमॉन हूँ?",

  subFooterPokemonDatabaseTitle: "पोकेमॉन डेटाबेस",
  subFooterPokedexLink: "पोकेडेक्स (जल्द ही आ रहा है)",
  subFooterTypeChartsLink: "प्रकार चार्ट (जल्द ही आ रहा है)",
  subFooterMoveListLink: "चाल सूची (जल्द ही आ रहा है)",

  subFooterBlogTitle: "ब्लॉग",
  subFooterLatestArticlesLink: "नवीनतम लेख (जल्द ही आ रहा है)",
  subFooterGuidesTutorialsLink: "गाइड और ट्यूटोरियल (जल्द ही आ रहा है)"
};
